import { Chip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { Cluster, ClusterStatusEnum } from '~/api/types';
import {
  CloseFilledIcon,
  ClosedWithErrorIcon,
  HourglassIcon,
  InProgressWarningIcon,
  LaunchIcon,
  PlayIcon,
  RunIcon,
} from '~/icons';
import { DATE_FORMAT, getDurationTime } from '~/utils';
import { StatusConfig } from './types';

const statusConfig: Record<string, StatusConfig> = {
  [ClusterStatusEnum.Running]: {
    color: '#DFF4C8',
    Icon: <RunIcon />,
    label: 'Running',
  },
  [ClusterStatusEnum.Starting]: {
    color: '#C2F1FD',
    Icon: <PlayIcon />,
    label: 'Starting',
  },
  [ClusterStatusEnum.BootStrapping]: {
    color: '#C2D5FF',
    Icon: <LaunchIcon />,
    label: 'Bootstrapping',
  },
  [ClusterStatusEnum.Waiting]: {
    color: '#E3C7B8',
    Icon: <HourglassIcon />,
    label: 'Waiting',
  },
  [ClusterStatusEnum.Terminating]: {
    color: '#FFEBBF',
    Icon: <InProgressWarningIcon />,
    label: 'Terminating',
  },
  [ClusterStatusEnum.Terminated]: {
    color: '#FFBAC7',
    Icon: <CloseFilledIcon />,
    label: 'Terminated',
  },
  [ClusterStatusEnum.TerminatedWithErrors]: {
    color: '#FF758F',
    Icon: <ClosedWithErrorIcon />,
    label: 'Terminated with errors',
  },
};

export const columns: GridColDef<Cluster>[] = [
  {
    field: 'aws_cluster_id',
    headerName: 'Cluster ID',
  },
  {
    field: 'name',
    headerName: 'Cluster Name',
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1.5,
    renderCell: ({ row }: GridRenderCellParams) => (
      <Chip
        icon={statusConfig[row.status].Icon}
        label={statusConfig[row.status].label}
        sx={{
          p: 1,
          fontSize: '1.5rem',
          backgroundColor: statusConfig[row.status].color || 'transparent',
        }}
      />
    ),
  },
  {
    field: 'created',
    headerName: 'Creation Time',
    renderCell: ({ row }: GridRenderCellParams) => format(new Date(row.created), DATE_FORMAT),
  },
  {
    field: 'creator',
    headerName: 'Created By',
    valueGetter: (_, row) => `${row.creator?.first_name} ${row.creator?.last_name}`,
  },
  {
    field: 'elapsed',
    headerName: 'Elapsed Time',
    renderCell: ({ row }: GridRenderCellParams) => getDurationTime(row.elapsed),
  },
];
